"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hyperlink = void 0;
var LftLink_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftLink"));
var react_1 = __importDefault(require("react"));
var Hyperlink = function (_a) {
    var label = _a.label, pathTo = _a.pathTo, tabIndex = _a.tabIndex, bgColor = _a.bgColor, disabled = _a.disabled, target = _a.target, hasIcon = _a.hasIcon, onClick = _a.onClick;
    return (react_1.default.createElement(LftLink_1.default, { href: pathTo, label: label, bgColor: bgColor, target: target, disabled: disabled, hasIcon: hasIcon, tabIndex: tabIndex, lftClick: onClick }));
};
exports.Hyperlink = Hyperlink;
